import './App.css';
import React, { useState } from 'react'
import MainPage from './components/mainPage/mainPage';
import Header from './components/header/header';
import AgeGate from './components/ageGate/ageGate';
import MobileFooter from './components/mobileFooter/mobileFooter';

function App() {

  const [ageGate, setAgeGate] = useState(localStorage.getItem("ageGate") || "false")
  const handleAgeGate = (value) => setAgeGate(value)

  return (
    <div className="App">

      {ageGate !== "true" &&
        <div className="soonStarting">
          <AgeGate handleAgeGate={handleAgeGate} />
        </div>}


      <MainPage />
      <Header />

      <MobileFooter />
    </div>
  );
}

export default App;
